(function () {
  /**
   * Unpublished Vehicle Finder map (1 Sep 2026).
   * Canonical collection first. 0-product vehicles already point at make TC.
   * Never land on *-2 / *-3 duplicate handles.
   */
  var MAKE_TC = {
    Toyota: '/collections/throttle-controllers-toyota',
    Ford: '/collections/throttle-controllers-ford',
    Nissan: '/collections/throttle-controllers-nissan',
    Mitsubishi: '/collections/throttle-controllers-mitsubishi',
    Isuzu: '/collections/throttle-controllers-isuzu',
    Mazda: '/collections/throttle-controllers-mazda',
    Jeep: '/collections/throttle-controllers-jeep',
    Volkswagen: '/collections/throttle-controllers-volkswagen',
    Holden: '/collections/throttle-controllers-holden',
    'Land Rover': '/collections/throttle-controllers-land-rover',
    Suzuki: '/collections/throttle-controllers-suzuki',
    Chevrolet: '/collections/throttle-controllers-chevrolet',
    Lexus: '/collections/throttle-controllers-lexus'
  };

  var FALLBACK = {
    'toyota-prado-250': MAKE_TC.Toyota,
    'toyota-landcruiser-300-series': MAKE_TC.Toyota,
    'ford-ranger-pk': MAKE_TC.Ford,
    'ford-everest-next': MAKE_TC.Ford,
    'ford-everest-ua': MAKE_TC.Ford,
    'nissan-navara-np300': MAKE_TC.Nissan,
    'nissan-patrol-y62': MAKE_TC.Nissan,
    'nissan-patrol-y61-gu': MAKE_TC.Nissan,
    'nissan-pathfinder-r52': MAKE_TC.Nissan,
    'volkswagen-amarok': MAKE_TC.Volkswagen,
    'gwm-cannon-alpha': '/collections/throttle-controllers',
    'jeep-wrangler-jk': MAKE_TC.Jeep,
    'holden-colorado-rc': MAKE_TC.Holden
  };

  var CANONICAL = {
    'Toyota|Hilux N80': '/collections/toyota-hilux-n80',
    'Toyota|Hilux N70': '/collections/toyota-hilux-n70',
    'Toyota|Prado J150': '/collections/toyota-prado-150',
    'Toyota|Prado 150': '/collections/toyota-prado-150',
    'Toyota|Prado J120': '/collections/toyota-prado-120',
    'Toyota|Prado 120': '/collections/toyota-prado-120',
    'Toyota|Prado 250': FALLBACK['toyota-prado-250'],
    'Toyota|LandCruiser 200': '/collections/toyota-landcruiser-200-series',
    'Toyota|LandCruiser 300': FALLBACK['toyota-landcruiser-300-series'],
    'Toyota|LandCruiser 70 Series': '/collections/toyota-landcruiser-79-series',
    'Toyota|FJ Cruiser': '/collections/toyota-fj-cruiser',
    'Toyota|Fortuner': '/collections/toyota-fortuner',
    'Toyota|AN50': '/collections/toyota-fortuner',
    'Toyota|AN150': '/collections/toyota-fortuner',
    'Ford|Ranger PX1': '/collections/ford-ranger-pxi',
    'Ford|Ranger PX2': '/collections/ford-ranger-pxii',
    'Ford|Ranger PX3': '/collections/ford-ranger-pxiii',
    'Ford|PX3/PX4': '/collections/ford-ranger-pxiii',
    'Ford|Ranger Next Gen': '/collections/ford-ranger',
    'Ford|NextGen T6': '/collections/ford-ranger',
    'Ford|Ranger PK': FALLBACK['ford-ranger-pk'],
    'Ford|Raptor': '/collections/ford-raptor',
    'Ford|Ranger Raptor': '/collections/ford-raptor-pxiii',
    'Ford|Everest Next Gen': FALLBACK['ford-everest-next'],
    'Ford|Everest UA': FALLBACK['ford-everest-ua'],
    'Mitsubishi|Triton MV': '/collections/mitsubishi-triton-mv',
    'Mitsubishi|Triton MQ/MR': '/collections/mitsubishi-triton-mq',
    'Mitsubishi|Triton': '/collections/mitsubishi-triton-mq',
    'Mitsubishi|Triton ML/MN': '/collections/mitsubishi-triton-ml',
    'Isuzu|D-Max RG': '/collections/isuzu-d-max-rg',
    'Isuzu|D-Max': '/collections/isuzu-d-max-rg',
    'Isuzu|D-Max TF': '/collections/isuzu-d-max-tf',
    'Isuzu|D-Max RC': '/collections/isuzu-d-max-rc',
    'Isuzu|MU-X RJ': '/collections/isuzu-mu-x-rj',
    'Isuzu|MU-X RF': '/collections/isuzu-mu-x-rf',
    'Isuzu|MUX': '/collections/isuzu-mux-uj',
    'Mazda|BT-50 TF': '/collections/mazda-bt-50-tf',
    'Mazda|BT-50 UN': '/collections/mazda-bt-50-un',
    'Mazda|BT-50': '/collections/mazda-bt-50',
    'Nissan|Navara NP300': FALLBACK['nissan-navara-np300'],
    'Nissan|Navara D40': '/collections/nissan-navara-d40',
    'Nissan|Patrol Y62': FALLBACK['nissan-patrol-y62'],
    'Nissan|Patrol Y61 GU': FALLBACK['nissan-patrol-y61-gu'],
    'Nissan|Pathfinder R51': '/collections/nissan-pathfinder-r51',
    'Nissan|Pathfinder R52': FALLBACK['nissan-pathfinder-r52'],
    'Suzuki|Jimny': '/collections/suzuki-jimny-jb74',
    'Suzuki|Jimny SN413': '/collections/suzuki-jimny-sn413',
    'Volkswagen|Amarok NF': '/collections/volkswagen-amarok-nf',
    'Volkswagen|Amarok': FALLBACK['volkswagen-amarok'],
    'Volkswagen|Amarok 2H': FALLBACK['volkswagen-amarok'],
    'GWM|Cannon': '/collections/gwm-cannon-npw',
    'GWM|Cannon Alpha': FALLBACK['gwm-cannon-alpha'],
    'GWM|Tank 300': '/collections/gwm-tank-300',
    'Jeep|Wrangler JL': '/collections/jeep-wrangler',
    'Jeep|Wrangler JK': FALLBACK['jeep-wrangler-jk'],
    'Jeep|Gladiator JT': '/collections/jeep-gladiator-jt',
    'Jeep|Grand Cherokee WL': '/collections/jeep-grand-cherokee-wl',
    'LDV|T60': '/collections/ldv-t60',
    'Holden|RG Colorado': '/collections/holden-colorado-rg',
    'Holden|Colorado RC': FALLBACK['holden-colorado-rc']
  };

  window.ROAR_FINDER = { canonical: CANONICAL, fallback: FALLBACK, makeTc: MAKE_TC };

  function sanitize(url) {
    if (!url) return '/collections/throttle-controllers';
    if (/-2$/.test(url) || /-3$/.test(url) || /-4$/.test(url)) {
      return '/collections/throttle-controllers';
    }
    var handle = url.replace('/collections/', '');
    if (FALLBACK[handle]) return FALLBACK[handle];
    return url;
  }

  function urlFor(make, model) {
    var key = make + '|' + model;
    if (CANONICAL[key]) return sanitize(CANONICAL[key]);
    if (MAKE_TC[make]) return MAKE_TC[make];
    return '/collections/throttle-controllers';
  }

  function go(make, model) {
    window.location = urlFor(make, model);
  }

  var MODELS = {};
  Object.keys(CANONICAL).forEach(function (key) {
    var parts = key.split('|');
    var make = parts[0];
    var model = parts[1];
    if (!MODELS[make]) MODELS[make] = [];
    if (MODELS[make].indexOf(model) === -1) MODELS[make].push(model);
  });

  document.querySelectorAll('[data-roar-finder]').forEach(function (root) {
    var makeSel = root.querySelector('[data-roar-make]');
    var modelSel = root.querySelector('[data-roar-model]');
    var form = root.querySelector('[data-roar-finder-form]');
    var err = root.querySelector('[data-roar-finder-err]');
    var type = root.querySelector('[data-roar-typeahead]');
    var suggest = root.querySelector('[data-roar-suggest]');

    Object.keys(MODELS).sort().forEach(function (m) {
      var o = document.createElement('option');
      o.value = m;
      o.textContent = m;
      makeSel.appendChild(o);
    });

    makeSel.addEventListener('change', function () {
      modelSel.innerHTML = '<option value="">Select model</option>';
      modelSel.disabled = !makeSel.value;
      (MODELS[makeSel.value] || []).forEach(function (model) {
        var o = document.createElement('option');
        o.value = model;
        o.textContent = model;
        modelSel.appendChild(o);
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!makeSel.value || !modelSel.value) {
        err.hidden = false;
        return;
      }
      err.hidden = true;
      go(makeSel.value, modelSel.value);
    });

    function allKeys() {
      return Object.keys(CANONICAL).map(function (k) {
        var p = k.split('|');
        return { key: k, make: p[0], model: p[1], label: p[0] + ' ' + p[1] };
      });
    }

    if (type && suggest) {
      type.addEventListener('input', function () {
        var q = type.value.trim().toLowerCase();
        suggest.innerHTML = '';
        if (q.length < 2) { suggest.hidden = true; return; }
        var hits = allKeys().filter(function (row) { return row.label.toLowerCase().indexOf(q) !== -1; }).slice(0, 8);
        hits.forEach(function (row) {
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = row.label;
          b.addEventListener('click', function () { go(row.make, row.model); });
          li.appendChild(b);
          suggest.appendChild(li);
        });
        suggest.hidden = hits.length === 0;
      });
    }
  });
})();
